
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import WarningIcon from '@mui/icons-material/Warning';
import MDTypography from "../../../components/MDTypography";
import {
    Alert, Chip,
    FormControl,
    Skeleton
} from "@mui/material";
import MDInput from "../../../components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import MDButton from "../../../components/MDButton";
import LocalStorage from "../../../utils/LocalStorage";
import {
    ownerSelected,
} from "../../../actions/inventory/inventoryAction";
import Fade from "@mui/material/Fade";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDebounce} from "use-debounce";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    addKeyAndToken, addToken,
    authRegister,
    get_sub_role_list, getAccessToken, getApiKeys,
    Logout,
    onErrorAlert,
    onSuccessAlert,
    subCustomerFilter,
} from "../../../actions";
import {noop} from "lodash";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import MDBox from "../../../components/MDBox";
import { v4 as uuidv4 } from 'uuid';
import {COLUMN_WIDTH} from "../../../constants";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CurrentStateLoading from "../../../examples/Loading/CurrentStateLoading";
import {MaterialReactTable, useMaterialReactTable} from "material-react-table";
import DownloadIcon from "@mui/icons-material/Download";
import {AlertTitle, LoadingButton} from "@mui/lab";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Typography from "@mui/material/Typography";
import {MRT_Localization_EN} from "material-react-table/locales/en";
import {MRT_Localization_ZH_HANS} from "material-react-table/locales/zh-Hans";

const OauthCredential = () => {

    const initialCredentials = [
        {id:1,rowNum:1,apiParams:'app_key',apiParamsValue:''},
        {id:2,rowNum:2,apiParams:'app_secret',apiParamsValue:''},
        {id:3,rowNum:3,apiParams:'access_token',apiParamsValue:''},
    ]

    const {t, i18n} = useTranslation();
    const [condition, setCondition] = useState('')
    const [isActive, setIsActive] = useState(null)
    const [loading, setLoading] = useState(false)
    const [value] = useDebounce(condition, 800);
    const nav = useNavigate()
    const dispatch = useDispatch()
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const [total,setTotal] = useState(0)
    const [data,setData] = useState([...initialCredentials])
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50, //customize the default page size
    });
    const [isOpen, setIsOpen] = useState(false)
    const [transferData, setTransferData] = useState({})
    const [type, setType] = useState('Add')
    const [currentRow,setCurrentRow] = useState({})
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const [owner,setOwner] = useState(null)
    const [reset,setReset] = useState([])
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 500);
    const [ownerList ,setOwnerList] =useState([])
    const [triggerFetch, setTriggerFetch] = useState(false);
    const lastPayloadRef = React.useRef(null);

    const col = { left: ['rowNum','apiParams'] , right: ['activeAction']}
    const mobileCol = { left: ['mrt-row-numbers','mrt-row-actions'] }
    const mdCol = {  left: ['mrt-row-numbers','userName','mrt-row-actions']}
    const [columnPinning, setColumnPinning] = useState(col);
    const [exportLoading,setExportLoading] = useState(false)
    const [showAddBtn,setShowAddBtn] = useState(false)
    const [appKey,setAppKey] = useState('')
    const [appSecret,setAppSecret] = useState('')
    const [token,setToken] = useState('')
    const [rowVisibility, setRowVisibility] = React.useState({});
    const haveCard = useSelector(state => state?.system?.haveCard, (prev, next) => prev === next)
    function maskString(str) {
        if (str.length <= 4) {
            return str; // 如果字符串长度小于等于4，不做任何处理
        }
        return '*'.repeat(str.length - 4) + str.slice(-4);
    }

    const handleVisibilityToggle = (rowIndex) => {
        setRowVisibility((prevState) => ({
            ...prevState,
            [rowIndex]: !prevState[rowIndex], // Toggle visibility for the specific row
        }));
    };
    const columns = [
        {
            accessorKey: 'rowNum',
            header: t("OauthCredentialPage.Row"),
            size: 90,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },

        {
            accessorKey: 'apiParams',
            header: t("OauthCredentialPage.API Params Key"),
            size:  180,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'apiParamsValue',
            header: t("OauthCredentialPage.API Params Value"),
            size: 850,
            Cell: ({cell}) => {

                // Custom rendering logic for apiParamsValue
                const value = cell.getValue();
                const isVisible = rowVisibility[cell.row.index] || false;
                return (
                    <div style={{display:'flex',justifyContent:'space-between', alignItems:'center',width:'100%'}}>
                        <div>
                            {cell.row.index === 1? value: (!isVisible? maskString(value):value)}
                        </div>
                        <div>

                            {cell.row.index !== 1 && !isVisible && <IconButton aria-label="copy" size="small" color="primary" onClick={() => handleVisibilityToggle(cell.row.index)}>
                                <VisibilityIcon fontSize="small"/>
                            </IconButton>}
                            {cell.row.index !== 1 && isVisible && <IconButton aria-label="copy" size="small" color="primary" onClick={() => handleVisibilityToggle(cell.row.index)}>
                                <VisibilityOffIcon fontSize="small"/>
                            </IconButton>}
                            <IconButton aria-label="copy" size="small" color="primary" onClick={()=>handleCellCopyClick(value)}>
                                <ContentCopyIcon fontSize="small"/>
                            </IconButton>
                        </div>

                    </div>
                );
            },
            muiTableBodyCellProps: ({cell}) => ({
            }),
        }


    ]






    useEffect(() => {
        if (!checkPermission(PERMISSION_DICT.OpenapiGetAppToken) || !checkPermission(PERMISSION_DICT.OpenapiGetAppToken)){
            return
        }

        const axiosGet = async () => {
            setLoading(true)
            await dispatch(getApiKeys(onKeySuccess, onError))
        }
        haveCard &&  axiosGet().then()

    }, [haveCard]);

    useEffect(()=>{
        setData(
            [
                {id:1,rowNum:1,apiParams:'app_key',apiParamsValue:appKey},
                {id:2,rowNum:2,apiParams:'app_secret',apiParamsValue:appSecret},
                {id:3,rowNum:3,apiParams:'access_token',apiParamsValue:token},
            ]
        )
    },[appSecret,appKey,token])

    const onKeySuccess = (data) => {
        if(!data?.appKey || data?.appKey === ''){
            setShowAddBtn(true)
            setLoading(false)

        } else {

            const appKey = data.appKey
            const appSecret = data.appSecret
            const axiosGet = async () => {
                await dispatch(getAccessToken({ownerId:null,appKey,appSecret},(msg)=>{

                    if(msg === '' ||!msg){
                        setShowAddBtn(true)
                        setAppKey(appKey)
                        setAppSecret(appSecret)
                        setLoading(false)
                    } else {
                        setShowAddBtn(false)
                        setAppKey(appKey)
                        setAppSecret(appSecret)
                        setToken(msg)
                        setLoading(false)
                    }

                }, onError))
            }

            axiosGet().then()

        }
    }

    const handleCellCopyClick = (text) => {
        const textToCopy = text
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };


    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }


    const onGenerateKeySuccess = (data) => {
        const appKey = data.appKey
        const appSecret = data.appSecret

        const axiosGet = async () => {
            await dispatch(addToken({ownerId:null,appKey,appSecret},(msg)=>{

                if(msg === '' ||!msg){
                    setShowAddBtn(true)
                    setAppKey(appKey)
                    setAppSecret(appSecret)
                } else {
                    setShowAddBtn(false)
                    setAppKey(appKey)
                    setAppSecret(appSecret)
                    setToken(msg)
                }

            }, onError))
        }

        axiosGet().then()


    }

    const handleAddKeyAndToken = () => {

        const axiosGet = async () => {
            await dispatch(addKeyAndToken({ownerId:null},onGenerateKeySuccess, onError))
        }

        axiosGet().then()
    }



    function CustomerToolbar() {


        return (
            <MDBox sx={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100%' }}>
                {!checkPermission(PERMISSION_DICT.QueryOwnerInfo) && haveCard && checkPermission(PERMISSION_DICT.OpenapiGenerateAppToken) && checkPermission(PERMISSION_DICT.OpenapiGenerateAppInfo)  && (
                    <MDButton
                        startIcon={<AddCircleOutlineIcon />}
                        color={'info'}
                        variant={'contained'}
                        onClick={handleAddKeyAndToken}
                        disabled={loading || !showAddBtn || !haveCard}
                    >
                        {t("OauthCredentialPage.Add Credentials")}
                    </MDButton>
                )}

            </MDBox>
        );
    }


    const table = useMaterialReactTable({
        enableColumnActions: false,
        columns: columns,
        data,
        enableSorting: false,
        enableColumnPinning: false,
        enableColumnFilters:false,
        enableToolbarInternalActions:false,
        enableFullScreenToggle:false,
        enableGlobalFilter:false,
        enableBottomToolbar: false,
        getRowId: (row) => (row.id),
        enableRowSelection: false,
        enableRowActions: false,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                size: 60, //if using layoutMode that is not 'semantic', the columns will not auto-size, so you need to set the size manually
                grow: false,
            },
        },
        positionActionsColumn: 'last',
        enableRowNumbers: false,
        rowNumberDisplayMode: 'static',
        rowCount:total,
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        enableColumnResizing: false,

        enableStickyHeader: true,
        enableStickyFooter: true,
        manualPagination: true,
        enableDensityToggle: false,
        enableBatchRowSelection: true,
        localization:languageSelect === 'en'?MRT_Localization_EN:MRT_Localization_ZH_HANS,
        initialState: {
            density: 'compact',
            columnVisibility: {
                ownerId:checkPermission(PERMISSION_DICT.QueryOwnerInfo),
                ownerName: checkPermission(PERMISSION_DICT.QueryOwnerInfo),
                totalVolume:false,
                totalPrice:false,
                totalWeight:false,
                lockStatus:false,
                orderDueDate:false,
                lockType:false,
                wmsShipMode:false,
                invState:false,
                signState:false,
                processState:false,
                executeState:false,
                businessType:false,
                hangStatus:false,
                expectedShipmentTime:false,
                requiredDeliveryTime:false,
                consigneeId:false,
                consigneeName:false,
                consigneeContact:false,
                consigneeTel1:false
            },
        },
        onPaginationChange:setPagination,
        state: {
            pagination,
            rowSelection,
            isLoading:loading,
            showLoadingOverlay:false,
            showSkeletons:loading,
            showAlertBanner:false,
        },
        onRowSelectionChange:setRowSelection,
        muiPaginationProps: {
            rowsPerPageOptions: [50, 100, 200],
            showFirstButton: true,
            showLastButton: true,
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            size:'small',
        },
        muiTableBodyCellProps:({ table }) => ({

            sx: (theme) => ({
                height:'40px',
            }),
            onClick: (event) => { event.preventDefault();}
        }),
        muiTableContainerProps: ({ table }) => ({
            sx: {

                maxHeight: table.getState().isFullScreen ?  undefined:640,
            },
        }),
        renderTopToolbarCustomActions: CustomerToolbar,
        muiTopToolbarProps:{
            sx: (theme) => ({
                maxWidth:'100%',
                background: theme.palette.background.table,
                padding:'20px',
                '& > div': {
                    padding: '0px',
                },
                '& > div:nth-of-type(2)': {
                    display:'flex',
                    flexWrap:'wrap'
                },
            }),
        },
        muiBottomToolbarProps:{sx: (theme) => ({backgroundColor:`${theme.palette.background.card} !important`})},
        muiTablePaperProps:{sx:
                {
                    boxShadow:'none',
                    '& > div:nth-of-type(1)': {
                        minHeight: '0', // 或者 'auto'
                    },
                }
        },
        muiSearchTextFieldProps:{
            placeholder: 'Search current page...',
        }



    });

    return (<React.Fragment>
        <Fade in={true} mountOnEnter unmountOnExit >
            <MDBox pt={2} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        {/*<Card>*/}

                            <MDBox py={4} mt={0} px={4} >
                                <Alert severity="info" icon={<WarningIcon fontSize="inherit" color={'error'}/>}>
                                    <AlertTitle ><MDBox>{t("OauthCredentialPage.Attention")}</MDBox></AlertTitle>
                                    <MDBox>
                                        <span
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '4px 8px',
                                                borderRadius: '5px',
                                                marginRight: '16px',
                                                fontSize: '0.875rem',
                                                lineHeight: '1.75',
                                                fontWeight: 400,
                                                color: 'rgba(0, 0, 0, 0.87)',
                                                backgroundColor: 'lightgrey',
                                            }}
                                        >
    app_secret
  </span>
                                        <MDTypography variant={'button'} fontWeight={'medium'} color="text" textGradient>
                                            {t("OauthCredentialPage.will only be displayed once immediately after creation. When retrieving it later, only the last 4 digits will be shown.")}
                                        </MDTypography>
                                    </MDBox>
                                </Alert>
                                    <MaterialReactTable table={table} />
                            </MDBox>

                        {/*</Card>*/}
                    </Grid>
                </Grid>
            </MDBox>
        </Fade>
    </React.Fragment>)
}

export default OauthCredential